export interface ProductTrimmingSpec {
  id: string;
  productId: string;
  trimmingKey: string;
  trimmingDescription: string;
  section: string;
  dimensions: string;
  composition: string;
}
